// import React from "react";
// import s1 from "../assets/s1.png";
// import so1 from "../assets/so1.png";
// import so2 from "../assets/so2.png";
// import so3 from "../assets/so3.png";
// import PhoneHeader from "./PhoneHeader";

// const ITTechnology = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches.",
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk.",
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases.",
//     },
//   ];
//   return (
//     <>
//       <PhoneHeader title="IT & Technology" className="d-md-none d-block" />
//       <div className="container-fluid d-md-block d-none">
//         <div className="text-center top-heading section">
//           <h1>IT & Technology</h1>
//         </div>
//       </div>
//       <div className="container">
//         <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>

//         <div className="row justify-content-center g-4">
//           <h2
//             className="mt-4 mb-5"
//             style={{ textAlign: "center", fontWeight: "600" }}
//           >
//             Services Offered
//           </h2>
//           {/* Software Development */}
//           <div className="col-12 col-sm-6 col-md-4">
//             <div
//               className="p-4 text-center rounded-4 w-100 d-flex flex-column"
//               style={{ backgroundColor: "#FFDED3" }}
//             >
//               <img
//                 src={so1}
//                 alt="Software Development"
//                 className="mb-3 img-fluid"
//               />
//               <h5 className="fw-semibold">Software Development</h5>
//               <p>Custom agent apps, admin dashboards.</p>
//             </div>
//           </div>

//           {/* Hardware Support */}
//           <div className="col-12 col-sm-6 col-md-4">
//             <div
//               className="p-4 text-center rounded-4 w-100 d-flex flex-column"
//               style={{ backgroundColor: "#E0FBFF" }}
//             >
//               <img
//                 src={so2}
//                 alt="Hardware Support"
//                 className="mb-3 img-fluid"
//               />
//               <h5 className="fw-semibold">Hardware Support</h5>
//               <p>Biometric devices, micro-ATMs, PoS devices.</p>
//             </div>
//           </div>

//           {/* Network & Maintenance */}
//           <div className="col-12 col-sm-6 col-md-4">
//             <div
//               className="p-4 text-center rounded-4 w-100 d-flex flex-column"
//               style={{ backgroundColor: "#EBF4E7" }}
//             >
//               <img
//                 src={so3}
//                 alt="Network & Maintenance"
//                 className="mb-3 img-fluid"
//               />
//               <h5 className="fw-semibold">Network & Maintenance</h5>
//               <p>Set up, manage, and maintain your infrastructure.</p>
//             </div>
//           </div>
//         </div>

//         {/* benefits */}
//         <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Professional tech support, eliminating downtime.
//                   </h5>
//                   <p className="text-start">
//                     One-stop bill payment portal for multiple services.{" "}
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">
//                     Scalable systems tailored to grow as your business expands.
//                   </h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Secure and compliant infrastructure.
//                   </h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled
//                     like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>
//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{ fontWeight: "700" }}>
//                     {item.title}
//                   </h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ITTechnology;
import React from "react";
import s1 from "../assets/s1.png";
// import solution from "../assets/solution.png";
// import solution1 from "../assets/ss1.png";
// import solution2 from "../assets/ss2.png";
// import solution3 from "../assets/ss3.png";
// import solution4 from "../assets/ss4.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const ITTechnology = () => {
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">IT Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong> */}
              Our IT services are designed to help businesses streamline
              operations, enhance security, and adopt modern digital solutions
              for long-term growth. With a focus on reliability, innovation, and
              performance, we deliver end-to-end technology support that
              empowers organizations to stay ahead in a rapidly evolving digital
              world
            </p>
            <ul className="list-unstyled mb-4 mb-md-0">
              <li className="fw-bold mb-2"> • Expert Team with Industry Experience</li>
              <li className="fw-bold mb-2">• Reliable & Scalable Solutions</li>
              <li className="fw-bold mb-2">• Advanced Security Protocols</li>
              <li className="fw-bold mb-2">• Affordable Pricing Models</li>
              <li className="fw-bold mb-2">• Dedicated Customer Support</li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4 section">
          <h2
            className="mt-4 mb-5"
            style={{ textAlign: "center", fontWeight: "600" }}
          >
            Our Core IT Services
          </h2>
          {/* Software Development */}
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Website & Application Services</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">
                  • Website hosting and infrastructure management
                </li>
                <li className="mb-2">
                  • Custom website and application development
                </li>
                <li className="mb-2">
                  • Ongoing maintenance, updates, and performance optimization
                </li>
                <li className="mb-2">
                  • Content management system (CMS) support{" "}
                </li>
              </ul>
            </div>
          </div>

          {/* Hardware Support */}
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Cloud & Infrastructure Solutions</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">• Cloud hosting and migration</li>
                <li className="mb-2">• Server setup and management</li>
                <li className="mb-2">
                  • Scalable infrastructure for growing traffic
                </li>
                <li className="mb-2">
                  • Backup and disaster recovery solutions{" "}
                </li>
              </ul>
            </div>
          </div>

          {/* Network & Maintenance */}
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Cybersecurity Services</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">
                  • SSL certificates and secure configurations
                </li>
                <li className="mb-2">• Firewall and DDoS protection</li>
                <li className="mb-2">• Malware detection and removal</li>
                <li className="mb-2">
                  • User access control and data protection{" "}
                </li>
              </ul>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">IT Support & Maintenance</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">
                  • Proactive monitoring and issue resolution
                </li>
                <li className="mb-2">
                  • Software updates and patch management
                </li>
                <li className="mb-2">
                  • Troubleshooting and technical support
                </li>
                <li className="mb-2">• System performance monitoring </li>
              </ul>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Performance & Optimization</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">• Website speed and performance tuning</li>
                <li className="mb-2">• CDN and caching solutions</li>
                <li className="mb-2">• Database optimization</li>
                <li className="mb-2">• Technical SEO improvements </li>
              </ul>
            </div>
          </div>

          {/* <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              <h5 className="fw-semibold">Analytics & Monitoring</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">
                  • Website traffic and performance analytics
                </li>
                <li className="mb-2">• Uptime and error monitoring</li>
                <li className="mb-2">• Reporting and system health checks</li>
              </ul>
            </div>
          </div> */}

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Integration & Automation</h5>
              <ul
                className="list-unstyled mt-2 flex-grow-1"
                style={{ textAlign: "justify" }}
              >
                <li className="mb-2">• API integrations</li>
                <li className="mb-2">
                  • Payment gateway and third-party service integration
                </li>
                <li className="mb-2">• Email and notification systems</li>
                <li className="mb-2">• Business process automation </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">
            Benefits of Our IT Services
          </h2>

          <div className="row align-items-center">
            {/* IMAGE */}
            <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
              <img
                src={benfits} // Replace with your imported image
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%" , width: "100%"}}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7 m-auto">
              <ul className="list-unstyled mx-auto">
                <li className="mb-3">
                  • Customized IT solutions aligned with your business goals
                </li>
                <li className="mb-3">
                  • Scalable and flexible technology to support business growth
                </li>
                <li className="mb-3">
                  • Secure systems with advanced data protection
                </li>
                <li className="mb-3">
                  • Cost-effective IT infrastructure and management
                </li>
                <li className="mb-3">
                  • Improved operational efficiency and workflow automation
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ITTechnology;
